import React, { useState } from 'react'
import pluralize from 'pluralize'
import moment from "moment"
import { Select, Slider, DatePicker, TreeSelect } from 'antd'

import { usePet, stringifyDate, useToggle, useListData, presets } from '../../modules'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

const { RangePicker } = DatePicker

const ByItems = () => {
    const [gender, setGender] = useState()
    const [under, setUnder] = useState(150)
    const [over, setOver] = useState(0)
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const [itemGroups, setItemGroups] = useState([])
    const [routingGroups, setRoutingGroups] = useState([])
    const [reportGroups, setReportGroups] = useState([])
    const [string, setString] = useState('')
    const [category, setCategory] = useState()
    const [filter, setFilter] = useState()
    const [itemGroup, setItemGroup] = useState()
    const [routingGroup, setRoutingGroup] = useState()
    const [reportGroup, setReportGroup] = useState()
    const [newPt, setNew] = useState(0)
    const [revisit, setRevisit] = useState(0)

    const [salesModal, toggleSalesModal] = useToggle()
    const [byStaff, toggleByStaff] = useToggle()
    const [byMethod, toggleByMethod] = useToggle()

    const rangesOK = ranges?.length === 2 && ranges[0] && ranges[1]

    usePet('routingGroups', {}, { notify: true, callback: ({ data }) => setRoutingGroups(data.map(grp => ({
        value: JSON.stringify({ name: grp.name, type: 'Routing Group' }),
        title: grp.name,
        children: grp.categories.map(cat => ({
            value: JSON.stringify({ name: cat, type: 'Routing Group Category' }),
            title: cat,
        })),
    }))) })

    usePet('itemGroups', {}, { notify: true, callback: ({ data }) => setItemGroups(data.map(grp => ({
        value: JSON.stringify({ name: grp.name, type: 'Item Group' }),
        title: grp.name,
        children: grp.categories.map(cat => ({
            value: JSON.stringify({ name: cat, type: 'Item Group Category' }),
            title: cat,
        })),
    }))) })

    usePet('reportGroups', {}, { notify: true, callback: ({ data }) => setReportGroups(data.map(grp => ({
        value: JSON.stringify({ name: grp.name, type: 'Report Group' }),
        title: grp.name,
        children: grp.categories.map(cat => ({
            value: JSON.stringify({ name: cat, type: 'Report Group Category' }),
            title: cat,
        })),
    }))) })

    const [
        { loading, error, fetch: getSalesReport },
        { list: items = [], count },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('itemsReport', 
    ranges?.length === 2 && rangesOK ? 
        { 
            routingGroup,
            itemGroup,
            reportGroup,
            category,
            under,
            over,
            gender: gender,
            from: ranges[0]?._d ?? ranges[0], 
            to: ranges[1]?._d ?? ranges[1] 
        }
    : {}, { notify: true, manual: ranges?.length !== 2 || !ranges[0] || !ranges[1] }, 'ois')

    

    const [{ loading: pLoading, error: pError }, getNew] = usePet('patientsCount',
        ranges?.length === 2 && rangesOK ? 
            { 
                under,
                over,
                status: 'New',
                gender,
                from: ranges[0]?._d ?? ranges[0], 
                to: ranges[1]?._d ?? ranges[1] 
            }
        : {}
    , { notify: true, manual: ranges?.length !== 2 || !ranges[0] || !ranges[1], callback: ({ data }) => setNew(data ?? 0) })

    const [{ loading: rLoading, error: rError }, getRevisit] = usePet('patientsCount',
        ranges?.length === 2 && rangesOK ? 
            { 
                under,
                over,
                status: 'Revisit',
                gender,
                from: ranges[0]?._d ?? ranges[0], 
                to: ranges[1]?._d ?? ranges[1] 
            }
        : {}
    , { notify: true, manual: ranges?.length !== 2 || !ranges[0] || !ranges[1], callback: ({ data }) => setRevisit(data ?? 0) })

    const refresh = () => {
        navigate(1)
        getSalesReport()
        getRevisit()
        getNew()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const selectGender = val => {
        setGender(val === 'All' ? undefined : val)
        refresh()
    }

    const setAgeRanges = range => {
        if (range[0] !== 0)
            setOver(range[0])

        if (range[1] !== 150)
            setUnder(range[1])

        refresh()
    }

    let tree = [
        {
            value: 0,
            title: 'By Item Group',
            children: itemGroups
        },
        {
            value: 1,
            title: 'By Routing Group',
            children: routingGroups
        },
        {
            value: 2,
            title: 'By Report Group',
            children: reportGroups
        }
    ]
    
    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-between mb-8">
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                </div>
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                    <div class="w-100">
                        <Slider onAfterChange={ setAgeRanges } max={ 130 } tooltip={{ open: true }} range defaultValue={[0,18]}/>
                        <div className="flex w-64">
                            <span className="ml-2 mr-3 self-center">Select Age Ranges</span>
                        </div>
                    </div>
                    <Select
                        defaultValue="All"
                        style={{ width: 120 }}
                        onChange={ val => selectGender(val) }
                        options={[
                            { label: 'All', value: 'All' },
                            { label: 'Male', value: 'Male' },
                            { label: 'Female', value: 'Female' }
                        ]} />
                    <TreeSelect
                        treeLine
                        style={{ width: 300 }}
                        placeholder="Select Filter Criteria"
                        onChange={ val => {
                            if (isNaN(val)) {
                                let json = JSON.parse(val)
                                console.log(json)

                                setItemGroup()
                                setRoutingGroup()
                                setReportGroup()
                                setCategory()

                                switch (json.type) {
                                    case 'Report Group':
                                        setReportGroup(json.name)
                                        break
                                        
                                    case 'Routing Group':
                                        setRoutingGroup(json.name)
                                        break

                                    case 'Item Group':
                                        setItemGroup(json.name)
                                        break

                                    default:
                                        setCategory(json.name)
                                        break
                                }

                                refresh()
                                setFilter(val)
                            }
                        }}
                        value={ filter }
                        treeData={ tree } />
                    <RangePicker 
                        onChange={selectRange}
                        showTime
                        ranges={ presets }/>
                </div>
            </div>
            <div className="col-span-full px-4 py-4 xl:col-span-8 flex shadow-lg rounded-sm">
                <div className="mb-5 mx-10 p-8 border border-gray-200 bg-white">
                    <div className="text-xs font-semibold text-gray-400 uppercase mb-1">New Patients</div>
                    <Receive
                        error={ pError }
                        loading={ pLoading }
                        progress>
                        <h2 className="text-lg font-semibold text-gray-800 mb-2">{ newPt } { pluralize('Patient', newPt) }</h2>
                    </Receive>
                </div>
                <div className="mb-5 mx-10 p-8 border border-gray-200 bg-white">
                    <div className="text-xs font-semibold text-gray-400 uppercase mb-1">Revisiting Patients</div>
                    <Receive
                        error={ rError }
                        loading={ rLoading }
                        progress>
                        <h2 className="text-lg font-semibold text-gray-800 mb-2">{ revisit } { pluralize('Patient', revisit) }</h2>
                    </Receive>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800 mb-1">By Items</h2>
                        <span className="text-gray-500 text-xs italic ml-2">{ count } { pluralize('Patient', count) } Seen</span>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={loading}
                        error={error}>
                        {
                            items?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No.</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Item</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                items.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                { `${((page - 1) * limit) + (key + 1)}.` }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ item.patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="flex space-x-2 pl-1 items-center">
                                                                <div className="h-2 rounded-full shadow">{ item.name }</div>
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            { stringifyDate(item.date)  }
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No records { string.trim().length > 2 ? `matching "${string}"` : "" } were found</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
        </>
    )
}

export default ByItems